import { useEffect, useState, useRef } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import Card from "react-bootstrap/Card";
import { useDispatch } from "react-redux";
import { t } from "i18next";
import { useLocation } from "react-router-dom";
import { setSelectedRequisitionData } from "../../../Redux/Actions/Pages/Requisition";
import {
  commaSeperatedStrSlice,
  getLoadReqSectionTypeId,
} from "../../../Utils/Common/Requisition";
import { LoaderIcon } from "../../../Shared/Icons";
import SectionComp from "./SectionComp";
import { validationExpression } from "Utils/Auth";
function CustomToggle({ children, eventKey, isSelected, props }: any) {
  const dispatch = useDispatch();
  const location = useLocation();
  const removeSelectedRequisitionData = (
    nameToRemove: any,
    idToRemove: any
  ) => {
    dispatch(
      setSelectedRequisitionData((prevState: any) => {
        const filteredData = {
          requisitionName: prevState.requisitionName.filter(
            (name: any) => name !== nameToRemove
          ),
          requsitionId: prevState.requsitionId.filter(
            (id: any) => id !== idToRemove
          ),
        };
        return filteredData;
      })
    );
  };
  const decoratedOnClick = useAccordionButton(eventKey, (checked) => {
    const reqIdName = commaSeperatedStrSlice(eventKey);
    const arrayIds: any = [];
    const arrayName: any = [];
    arrayIds.push(reqIdName.requsitionId);
    arrayName.push(reqIdName.requisitionName);
    props.setSelectedReqIds({
      requsitionId: arrayIds,
      requisitionName: arrayName,
    });
    const obj = {
      requsitionId: arrayIds,
      requisitionName: arrayName,
    };

    if (checked) {
      dispatch(setSelectedRequisitionData(obj));
      const updatedInfectiousData = (props.infectiousData || []).map(
        (i: any) =>
          i.reqId === props.ReqConfig.reqId ? { ...i, isSelected: true } : i
      );
      props.setInfectiousData(updatedInfectiousData);
      props.setCheckReqType(true);

      if (props.LoadRequisitionSection) {
        const params = new URLSearchParams(window.location.search);
        const wfId = params.get("workflowId");
        const editReqId = location?.state?.reqId || 0;
        const editOrderId = location?.state?.orderid || 0;
        let groupIds: number[] = [];
        try {
          const parsed = JSON.parse(
            localStorage.getItem("insuranceGroupIds") || "[]"
          );
          if (Array.isArray(parsed)) groupIds = parsed;
        } catch {
          groupIds = [];
        }
        props.LoadRequisitionSection({
          facilityId: parseInt(localStorage.getItem("facilityID") || "0", 10),
          insuranceTypeId: parseInt(
            localStorage.getItem("insurnceID") || "0",
            10
          ),
          patientId: parseInt(localStorage.getItem("patientID") || "0", 10),
          pageId: 6,
          requisitionId: editReqId,
          requisitionOrderId: editOrderId,
          workflowId: wfId,
          isRequisitionExpand: true,
          reqTypeId: getLoadReqSectionTypeId(props.ReqConfig),
          groupIds,
        });
      }
    } else {
      removeSelectedRequisitionData(
        reqIdName.requisitionName,
        reqIdName.requsitionId
      );
      const updatedInfectiousData = (props.infectiousData || []).map(
        (i: any) =>
          String(i.reqId) === String(props.ReqConfig.reqId)
            ? { ...i, isSelected: false }
            : i
      );
      props.setInfectiousData(updatedInfectiousData);
      props.setCheckReqType(false);
    }
  });

  useEffect(() => {
    if (!isSelected) {
      removeSelectedRequisitionData(
        props.ReqConfig.requisitionName,
        props.ReqConfig.reqId
      );
    }
  }, [isSelected]);

  const isExpanding = !!props.expandingReqTypeIds?.[props.ReqConfig.reqId];

  return (
    <label className="form-check form-check-sm form-check-solid d-flex align-items-center">
      <input
        className="form-check-input mr-2"
        type="checkbox"
        defaultValue=""
        checked={isSelected}
        disabled={isExpanding}
        onChange={(e: any) => {
          decoratedOnClick(e.target.checked);
        }}
      />
      {children}
      {isExpanding && (
        <span className="ms-2">
          <LoaderIcon />
        </span>
      )}
    </label>
  );
}

const ReqSection = (props: any) => {
  const eventKey = props.ReqConfig.reqId + "," + props.ReqConfig.requistionName;
  const [activeKey, setActiveKey] = useState<string | null>(
    props.ReqConfig.isSelected ? eventKey : null
  );
  // Store original field validation state before dynamic req-based overrides
  const originalFieldValidationState = useRef<{
    [key: string]: { validationExpression: any; required: any };
  }>({});
  /** Only trigger default-panel selection once per select, not on every remount after Continue. */
  const defaultsAppliedForSelectionRef = useRef(false);
  const location = useLocation();

  useEffect(() => {
    if (props.ReqConfig.isSelected) {
      setActiveKey(eventKey);
      if (!defaultsAppliedForSelectionRef.current) {
        defaultsAppliedForSelectionRef.current = true;
        props.setIsSelectedByDefaultCompendiumData(
          !props.IsSelectedByDefaultCompendiumData
        );
      }
    } else {
      defaultsAppliedForSelectionRef.current = false;
      setActiveKey(null);
    }
  }, [props.ReqConfig.isSelected]);

  useEffect(() => {
    //add
    if (!location?.state?.reqId) {
      if (
        !props.ReqConfig.reqTypeBasedConfiguration ||
        !Array.isArray(props.Inputs)
      ) {
        return;
      }

      let hasChanges = false;
      try {
        const reqTypeBasedConfig =
          typeof props.ReqConfig.reqTypeBasedConfiguration === "string"
            ? JSON.parse(props.ReqConfig.reqTypeBasedConfiguration)
            : props.ReqConfig.reqTypeBasedConfiguration;

        const currentReqId = props.ReqConfig.reqId;

        if (Array.isArray(reqTypeBasedConfig)) {
          reqTypeBasedConfig.forEach((config: any) => {
            try {
              const requisitionIds =
                typeof config.RequisitionIds === "string"
                  ? JSON.parse(config.RequisitionIds)
                  : config.RequisitionIds;

              if (
                !Array.isArray(requisitionIds) ||
                !requisitionIds.includes(currentReqId)
              ) {
                return;
              }

              if (!Array.isArray(config.Fields)) return;
              const configType = String(config?.Type || "").toLowerCase();

              config.Fields.forEach((field: any) => {
                props.Inputs.forEach((input: any) => {
                  if (
                    input.sectionId !== field.SectionId ||
                    !Array.isArray(input.fields)
                  )
                    return;

                  input.fields.forEach((inputField: any) => {
                    if (inputField.systemFieldName !== field.ControlKey) return;

                    const fieldKey = `${input.sectionId}_${inputField.systemFieldName}`;
                    if (!originalFieldValidationState.current[fieldKey]) {
                      originalFieldValidationState.current[fieldKey] = {
                        validationExpression: inputField.validationExpression,
                        required: inputField.required,
                      };
                    }

                    if (props.ReqConfig.isSelected) {
                      if (configType === "required") {
                        if (inputField.required !== true) {
                          inputField.required = true;
                          hasChanges = true;
                        }
                        if (!inputField.validationExpression) {
                          inputField.validationExpression =
                            validationExpression;
                          hasChanges = true;
                        }
                      }
                    } else {
                      if (configType === "required") {
                        // Explicitly remove required behavior when requisition is unchecked
                        if (inputField.required !== false) {
                          inputField.required = false;
                          hasChanges = true;
                        }
                        if (inputField.validationExpression) {
                          inputField.validationExpression = "";
                          hasChanges = true;
                        }
                        inputField.enableRule = "";
                      }
                    }
                  });
                });
              });
            } catch (error) {
              console.error(
                "Error parsing RequisitionIds:",
                error,
                config?.RequisitionIds
              );
            }
          });
        }
        if (hasChanges && typeof props.setInputs === "function") {
          props.setInputs([...props.Inputs]);
        }
      } catch (error) {
        console.error(
          "Error parsing reqTypeBasedConfiguration:",
          error,
          props.ReqConfig.reqTypeBasedConfiguration
        );
      }
    }
    //edit
    if (location?.state?.reqId) {
      if (
        !props.ReqConfig.reqTypeBasedConfiguration ||
        !Array.isArray(props.Inputs)
      ) {
        return;
      }

      let hasChanges = false;
      try {
        const reqTypeBasedConfig =
          typeof props.ReqConfig.reqTypeBasedConfiguration === "string"
            ? JSON.parse(props.ReqConfig.reqTypeBasedConfiguration)
            : props.ReqConfig.reqTypeBasedConfiguration;

        const currentReqId = String(props.ReqConfig.reqId);

        if (Array.isArray(reqTypeBasedConfig)) {
          reqTypeBasedConfig.forEach((config: any) => {
            try {
              const requisitionIds =
                typeof config.RequisitionIds === "string"
                  ? JSON.parse(config.RequisitionIds)
                  : config.RequisitionIds;
              const normalizedRequisitionIds = Array.isArray(requisitionIds)
                ? requisitionIds.map((id: any) => String(id))
                : [];

              if (!Array.isArray(config.Fields)) return;
              const configType = String(config?.Type || "").toLowerCase();
              const isReqMatched =
                normalizedRequisitionIds.includes(currentReqId);

              config.Fields.forEach((field: any) => {
                props.Inputs.forEach((input: any) => {
                  if (
                    Number(input.sectionId) !== Number(field.SectionId) ||
                    !Array.isArray(input.fields)
                  ) {
                    return;
                  }

                  input.fields.forEach((inputField: any) => {
                    if (
                      String(inputField.systemFieldName)
                        .trim()
                        .toLowerCase() !==
                      String(field.ControlKey).trim().toLowerCase()
                    ) {
                      return;
                    }

                    const fieldKey = `${input.sectionId}_${inputField.systemFieldName}`;
                    if (!originalFieldValidationState.current[fieldKey]) {
                      originalFieldValidationState.current[fieldKey] = {
                        validationExpression: inputField.validationExpression,
                        required: inputField.required,
                      };
                    }

                    if (!isReqMatched && configType === "required") {
                      if (inputField.required !== "") {
                        inputField.required = "";
                        hasChanges = true;
                      }
                      if (inputField.validationExpression !== "") {
                        inputField.validationExpression = "";
                        hasChanges = true;
                      }
                      inputField.enableRule = "";
                      return;
                    }

                    if (props.ReqConfig.isSelected) {
                      if (configType === "required") {
                        if (inputField.required !== true) {
                          inputField.required = true;
                          hasChanges = true;
                        }
                        if (!inputField.validationExpression) {
                          inputField.validationExpression =
                            validationExpression;
                          hasChanges = true;
                        }
                      }
                    } else {
                      if (configType === "required") {
                        // Explicitly remove required behavior when requisition is unchecked
                        if (inputField.required !== false) {
                          inputField.required = false;
                          hasChanges = true;
                        }
                        if (inputField.validationExpression) {
                          inputField.validationExpression = "";
                          hasChanges = true;
                        }
                        inputField.enableRule = "";
                      }
                    }
                  });
                });
              });
            } catch (error) {
              console.error(
                "Error parsing RequisitionIds:",
                error,
                config?.RequisitionIds
              );
            }
          });
        }

        if (hasChanges && typeof props.setInputs === "function") {
          props.setInputs([...props.Inputs]);
        }
      } catch (error) {
        console.error(
          "Error parsing reqTypeBasedConfiguration:",
          error,
          props.ReqConfig.reqTypeBasedConfiguration
        );
      }
    }
  }, [
    props.ReqConfig.isSelected,
    props.ReqConfig.reqId,
    props.ReqConfig.reqTypeBasedConfiguration,
    props.Inputs,
  ]);
  return (
    <>
      <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <Accordion
          className={`crad rounded-3 ${props?.ReqConfig?.colour}`}
          style={{ border: `2px solid ${props?.ReqConfig?.colour}` }}
          activeKey={activeKey ? activeKey : null}
        >
          <Card.Header
            style={{ background: props?.ReqConfig?.colour }}
            className="px-4 h-35px rounded-3 border-0 min-h-40px pt-1 align-items-center d-flex"
          >
            <CustomToggle
              eventKey={
                props?.ReqConfig?.reqId + "," + props?.ReqConfig?.requistionName
              }
              isSelected={props.ReqConfig.isSelected}
              props={props}
            >
              <h6 className="mb-0">{t(props?.ReqConfig?.requistionName)}</h6>
            </CustomToggle>
          </Card.Header>
          <Accordion.Collapse
            eventKey={
              props?.ReqConfig?.reqId + "," + props?.ReqConfig?.requistionName
            }
          >
            <Card.Body className="p-3 ">
              {props.expandingReqTypeIds?.[props.ReqConfig.reqId] &&
                !props?.ReqConfig?.sections?.length && (
                  <div className="text-center py-4">
                    <LoaderIcon />
                  </div>
                )}
              <div className="row grid2">
                {Array.isArray(props?.ReqConfig?.sections) &&
                  props?.ReqConfig?.sections?.map(
                    (section: any, index: number) => (
                      <div
                        className={`${section.displayType} mb-4 ${section.cssStyle}`}
                        key={index}
                      >
                        <SectionComp
                          Section={section}
                          Inputs={props?.ReqConfig?.sections}
                          setInputs={props?.setInputs}
                          index={index}
                          formState={props?.formState}
                          setFormState={props?.setFormState}
                          setFormData={props?.setFormData}
                          setIsShown={props.setIsShown}
                          infectiousData={props.infectiousData}
                          setInfectiousData={props.setInfectiousData}
                          inputDataInputsForValidation={
                            props?.inputDataInputsForValidation
                          }
                          infectiousInputs={true}
                          errorFocussedInput={props?.errorFocussedInput}
                          rid={props?.rid}
                          rname={props?.ReqConfig?.requistionName}
                          apiCallCondition={props.apiCallCondition}
                          inputValueForSpecimen={props.inputValueForSpecimen}
                          setInputValueForSpecimen={
                            props.setInputValueForSpecimen
                          }
                          checkbox={props.checkbox}
                          setCheckbox={props.setCheckbox}
                          noMedication={props.noMedication}
                          setNoMedication={props.setNoMedication}
                          SignPadValue={props.SignPadValue}
                          setSignPadValue={props.setSignPadValue}
                          fields={section}
                          showButton={props.showButton}
                          setErrorFocussedInput={props.setErrorFocussedInput}
                          noFamilyHistroy={props.noFamilyHistroy}
                          setNoFamilyHistory={props.setNoFamilyHistory}
                          noActiveMedication={props.noActiveMedication}
                          setNoActiveMedication={props.setNoActiveMedication}
                          IsSelectedByDefaultCompendiumData={
                            props.IsSelectedByDefaultCompendiumData
                          }
                          setIsSelectedByDefaultCompendiumData={
                            props.setIsSelectedByDefaultCompendiumData
                          }
                          validationBackup={props.validationBackup}
                          setValidationBackup={props.setValidationBackup}
                          screening={props.screening}
                          setScreening={props.setScreening}
                          onDateValidityChange={props.onDateValidityChange}
                          showFields={props.showFields}
                          setDisabledField={props.setDisabledField}
                          AOEErrors={props.AOEErrors}
                          setAOEErrors={props.setAOEErrors}
                          AOEIDErrors={props.AOEIDErrors}
                          setAOEIDErrors={props.setAOEIDErrors}
                          medicationSelections={props.medicationSelections}
                          setMedicationSelections={
                            props.setMedicationSelections
                          }
                        />
                      </div>
                    )
                  )}
                <div className="col-12 col-sm-12 pb-4 grid-item grid-sizer"></div>
              </div>
            </Card.Body>
          </Accordion.Collapse>
        </Accordion>
      </div>
    </>
  );
};

export default ReqSection;
